<template>
    <img :src="currentQrImage" data-dark="/logo.png" data-light="/logo_light.png" alt="Logo" class="logo"
        loading="lazy" />
</template>

<script>
import { ref } from 'vue';
import { useThemeStore } from "../stores/themeStore";

export default {
    name: "Logo",
    data() {
        return {
            themeStore: useThemeStore(),
            currentQrImage: ref(""),
        }
    },
    methods: {
        updateQrImage() {
            this.currentQrImage = this.themeStore.isDark
                ? new URL("/logo.png", import.meta.url).href
                : new URL("/logo_light.png", import.meta.url).href;
        },
    },
    watch: {
        "themeStore.isDark": function () {
            this.updateQrImage();
        },
    },
    mounted() {
        this.updateQrImage();
    }
}
</script>

<style>
.logo {
    width: 145px;
    height: 26px;
    margin-top: 4px;
    cursor: pointer;
    margin-right: 10px;
    margin-left: 5px;
}
</style>
